"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const activities_1 = require("../../api/activities");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const configuration_1 = __importDefault(require("../apis/configuration/activities/configuration"));
class Activities {
    api = new activities_1.ActivityApi(configuration_1.default);
    save(activity) {
        const activityData = {
            // @ts-expect-error Topic is expected to be overwritten by the activity parameter.
            topic: '',
            createdAt: new Date(),
            ...activity,
            userReference: {
                zundId: AuthorizationStore_1.default.contactId ?? 'anonymous',
                name: AuthorizationStore_1.default.contactName,
                ...activity.userReference,
            },
            companyReference: {
                zundId: AuthorizationStore_1.default.customerId ?? 'anonymous',
                name: AuthorizationStore_1.default.customerName,
                ...activity.companyReference,
            },
            data: {
                salesChannelShopId: null,
                salesChannelZundId: AuthorizationStore_1.default.channelId,
                ...activity.data,
            },
        };
        return this.api.postActivity({ activityData });
    }
}
__decorate([
    bind_decorator_1.default
], Activities.prototype, "save", null);
exports.default = new Activities();
